import { useState } from "react";
import { useQueryClient, useQuery } from "@tanstack/react-query";
import { Table, Input, Empty } from "antd";
const { Search } = Input;

import BaseCard from "../../BaseCard";
import { fetchIndices } from "../../../utils/fetchers";
import { SkeletonTableTabs } from "../../skeletons/instruments";
import useLocale from "../../../hooks/useLocale";

import renderColumns from "./renderColumns";
export default function IndexesTable() {
    const locale = useLocale();
    const queryClient = useQueryClient();
    const {
        isLoading,
        isError,
        data: instrumentData,
    } = useQuery({
        queryKey: ["instrument", "indices"],
        queryFn: () => fetchIndices(),
    });

    const setDataSource = (data) => {
        const dataSource = data.indices
            .filter((item) => !item.hidden)
            .map((item, index) => {
                return {
                    ...item,
                    key: "index" + index,
                };
            });
        return dataSource;
    };

    const [count, setCount] = useState(0);
    const filterTable = (term) => {
        queryClient.setQueryData(["instrument", "indices"], (data) => {
            data?.indices
                ? (data.indices = data.indices.map((item) => {
                      const hasDescription = term ? item.descripcion?.toLowerCase().includes(term.toLowerCase()) : true;
                      return {
                          ...item,
                          hidden: !hasDescription,
                      };
                  }))
                : data;
            setCount(count + 1);
            return data;
        });
    };

    return (
        <>
            <BaseCard classNames={"cot-more-info-and-search"}>
                <i></i>

                <Search
                    className="--theme-light"
                    placeholder="Buscar"
                    style={{ maxWidth: 264 }}
                    onChange={(e) => filterTable(e.target.value)}
                    disabled={isError}
                />
            </BaseCard>

            {isLoading ? (
                <SkeletonTableTabs rows={10} withTabs={false} withSearchBar={false} />
            ) : isError ? (
                <Empty
                    className="empty-table pt-4"
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="No se han podido cargar los datos."
                />
            ) : (
                <Table
                    key="indexTable"
                    className="cot-product-table"
                    dataSource={setDataSource(instrumentData)}
                    columns={renderColumns(locale).indices}
                    showSorterTooltip={false}
                    onRow={(record) => {
                        return {
                            onClick: () => {},
                        };
                    }}
                    pagination={{
                        responsive: true,
                    }}
                />
            )}
        </>
    );
}
